import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GenerateSeatsService {

  constructor() { }

  canvasOnEditSeats(canvas: any, edit: boolean = true, pointer: string = 'pointer', editElement?: any, bookings?: any[]) {
    let objects = canvas._objects;
    objects.forEach(element => {
      // element.lockMovementY = edit;
      // element.lockMovementX = edit;
      // element.lockRotation = edit;
      // element.lockScalingFlip = edit;
      // element.lockScalingY = edit;
      // element.lockScalingX = edit;
      // element.hoverCursor = edit ? pointer : 'move';
      // element.selectable = pointer == 'pointer';
      if (element.groupSeat) {
        element.subTargetCheck = edit;
        element.perPixelTargetFind = edit;
        let arrayObject = element._objects[1];
        arrayObject.subTargetCheck = edit;
        arrayObject.perPixelTargetFind = edit;
        arrayObject._objects.forEach(seat => {
          let exist = bookings?.includes(seat.id);
          if (seat.eventSeat && !exist) {
            seat.hoverCursor = edit ? pointer : 'default';
            seat.selectable = true;
            // seat.visible = seat.isVisible;
          }
        });
      }
      if (!element.eventSeat) {
        element.selectable = false;
        element.hoverCursor = edit ? 'default' : pointer;
      }
    });
    return objects;
  }
}
